class Animations {
  constructor() {
    this.reveal();
    this.activateUnderline();
    this.activateCollageSequence();
    this.activateStaticCardsSequence();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.activateAnimateOnView();
      });
    });
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => {
      this.reveal();
      this.activateUnderline();
      this.activateCollageSequence();
      this.activateStaticCardsSequence();
      this.activateAnimateOnView();
    });

    window.addEventListener("resize", () => {
      this.activateAnimateOnView();
    });
  }

  reveal() {
    let reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => {
      let windowHeight = window.innerHeight;
      let elementTop = el.getBoundingClientRect().top;
      let elementVisible = 75;
      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  }

  activateUnderline() {
    let underlines = document.querySelectorAll(".animation-underline");
    underlines.forEach((el) => {
      if (el.classList.contains("underline-active")) return;

      let windowHeight = window.innerHeight;
      let elementTop = el.getBoundingClientRect().top;
      let elementVisible = 75;

      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("underline-active");
      }
    });
  }

  activateCollageSequence() {
    let medias = document.querySelectorAll(".text-image-collage-block__media");

    medias.forEach((media) => {
      if (media.classList.contains("is-sequence-visible")) return;

      let windowHeight = window.innerHeight;
      let elementTop = media.getBoundingClientRect().top;
      let elementVisible = 75;

      if (elementTop < windowHeight - elementVisible) {
        media.classList.add("is-sequence-visible");

        let images = media.querySelectorAll(".wp-block-image");
        images.forEach((img) => img.classList.add("is-fade-in-visible"));
      }
    });
  }

  activateAnimateOnView() {
    let animatedElements = document.querySelectorAll('[class*="animate__"]');

    animatedElements.forEach((el) => {
      if (
          el.classList.contains("is-animate-visible") ||
          el.classList.contains("is-animate-queued")
      ) return;

      let windowHeight = window.innerHeight;
      let elementTop = el.getBoundingClientRect().top;
      let elementVisible = 75;

      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("is-animate-queued");

        setTimeout(() => {
          el.classList.remove("is-animate-queued");
          el.classList.add("is-animate-visible");
        }, 180);
      }
    });
  }

  activateStaticCardsSequence() {
    const blocks = document.querySelectorAll(".static-cards-block");

    blocks.forEach((block) => {
      if (block.classList.contains("is-cards-visible")) return;

      const windowHeight = window.innerHeight;
      const elementTop = block.getBoundingClientRect().top;
      const elementVisible = 90;

      if (elementTop < windowHeight - elementVisible) {
        block.classList.add("is-cards-visible");
      }
    });
  }
}

export default Animations;
